import type { DialogStore } from "@ariakit/react";
import { sleep } from "@indietabletop/appkit";
import { useCallback } from "react";
import { toast } from "react-hot-toast";
import { useLocation } from "wouter";

export type SuccessReaction = {
  message?: string;
  navigateTo?: string;
};

export function useHandleSuccess(dialog?: DialogStore) {
  const [_, navigate] = useLocation();

  return useCallback(
    async ({ message, navigateTo }: SuccessReaction) => {
      dialog?.hide();

      if (navigateTo) {
        await sleep(400);
        navigate(navigateTo);
      }

      if (message) {
        toast(message);
      }
    },
    [navigate, dialog]
  );
}
